interface Tracking {
  referrer?: string;
  utm_source?: string;
}

type TrackingType = Tracking & {
  [key: string]: string;
};

export type ITrackTrackingNames = { Bing: string; Google: string };

// referrer should be document.referrer and search is from window.location.search
export const track = (
  referrer: string | null,
  search: string,
  trackingNames?: ITrackTrackingNames
) => {
  const sp = new URLSearchParams(search);
  const googleParam = sp.get('gclid') ?? sp.get('gbraid') ?? sp.get('wbraid');

  let init = false;
  const tracking: TrackingType = {};

  // infer utm_source from referrer (if possible)
  if (referrer) {
    tracking.referrer = referrer.split(/\/+/g)[1]; // remove http(s)://

    const sites = [
      [
        /google.[a-z]{2,3}(#|\?|\/|$)/,
        trackingNames?.Google || 'Google Organic',
      ],
      [/bing.[a-z]{2,3}(#|\?|\/|$)/, trackingNames?.Bing || 'Bing Organic'],
    ];

    const match = sites.find(([pattern]) =>
      (pattern as RegExp).test(tracking.referrer as string)
    );

    if (match) {
      const [, source] = match;
      tracking.utm_source = source as string;
      init = true;
    }
  }

  // set tracking parameters (utm_source overridden if set)
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']
    .filter((p) => sp.get(p))
    .map((p) => {
      tracking[p] = sp.get(p) as string;
      init = true;
    });

  // override utm_source if gclid, gbraid, wbraid is present
  if (googleParam) {
    tracking['utm_source'] = 'Adwords';
    tracking['utm_content'] = googleParam as string;
    init = true;
  }

  // set tracking cookie if we intend to initialize it
  if (init) {
    return tracking;
  }

  return null;
};

// search is from window.location.search
export const query = (search: string) => {
  const params = new URLSearchParams(search);
  const keys = Array.from(params.keys());
  const unique = new Set(keys);

  return Array.from(unique)
    .filter((key) => !key.match(/^utm_/))
    .reduce((acc, key) => {
      const value = params.getAll(key).filter((v) => v !== 'undefined');

      if (value.length < 1) {
        return acc;
      }

      if (value.length === 1) {
        return { ...acc, [key]: value[0] };
      }

      return { ...acc, [key]: [...value] };
    }, {});
};
